var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProngCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.208 45.1784H71.2083H71.2248C71.9321 45.1784 72.5895 44.9111 73.0948 44.41C73.5998 43.9092 73.8865 43.2409 73.8865 42.5386V39.3096C73.8865 37.856 72.7071 36.6698 71.2415 36.6697C71.2415 36.6697 71.2414 36.6697 71.2414 36.6697L54.3156 36.5714L54.2375 36.5709L54.2698 36.6421L54.7109 37.6141L54.2663 44.3576L53.8277 45.002L53.7749 45.0796L53.8687 45.0801L71.208 45.1784Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62845 45.1784L8.62817 45.1784L8.61165 45.1784C7.90434 45.1784 7.24701 44.9111 6.74168 44.41C6.23668 43.9092 5.95001 43.2409 5.95001 42.5386L5.95 39.3096C5.95 37.856 7.12935 36.6698 8.59497 36.6697C8.59501 36.6697 8.59506 36.6697 8.59511 36.6697L25.5209 36.5714L25.599 36.5709L25.5667 36.642L25.1256 37.6141L25.5702 44.3576L26.0088 45.002L26.0616 45.0796L25.9678 45.0801L8.62845 45.1784Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4463 40.1619C24.4463 48.5493 31.3182 55.3633 39.7525 55.3901V55.4066H39.8025C48.2762 55.4066 55.1587 48.5822 55.1587 40.1783C55.1587 31.7744 48.2762 24.95 39.8025 24.95C31.3289 24.95 24.4463 31.7579 24.4463 40.1619ZM25.3563 40.1783C25.3563 32.2729 31.8295 25.8532 39.8025 25.8532C47.759 25.8532 54.2488 32.273 54.2488 40.1783C54.2488 48.0837 47.7755 54.5034 39.8025 54.5034C31.8295 54.5034 25.3563 48.0837 25.3563 40.1783Z",
    fill: "#343333",
    stroke: "#343333",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0507 29.9993H29.5543V50.3245H50.0507V29.9993Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7878 25.7905L25.2946 40.1626L39.7878 54.5346L54.2809 40.1626L39.7878 25.7905Z",
    stroke: "#343333",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 30,
    r: 2,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 30,
    r: 2,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 50,
    r: 2,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 50,
    r: 2,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 30,
    r: 2,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 30,
    r: 2,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 50,
    r: 2,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 50,
    r: 2,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProngCrown);
export default __webpack_public_path__ + "static/media/Prong_Crown.0599cff2577143633b000aca4a596472.svg";
export { ForwardRef as ReactComponent };